/* eslint-disable import/no-unresolved */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Container, Box } from "@mui/material";
import * as Actions from "actions";

// Import Swiper styles
import 'swiper/swiper.min.css';
import './UserOffersFavNearbySlider.scss';

// import Custom Components
import UserOfferBoxItem from "components/elements/user/offers/UserOfferBoxItem";
import MockProductBox from "components/elements/main/MockProductBox";
import CustomSectionCreator from "components/CustomSectionCreator";
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

const UserOffersFavNearbySlider = (props) => {
  const {
      offers, userMainGetFavNearbyOffers, isLoading, history
  } = props;

  useEffect(() => {
      userMainGetFavNearbyOffers();
  }, []);


    const breakpoints = {
        300: {
            slidesPerView: 2.0,
            spaceBetween: 20,
        },
        340: {
            slidesPerView: 2.2,
            spaceBetween: 20,
        },
        380: {
            slidesPerView: 2.4,
            spaceBetween: 20,
        },
        420: {
            slidesPerView: 2.6,
            spaceBetween: 20,
        },
        480: {
            slidesPerView: 2.8,
            spaceBetween: 20,
        },
        640: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
        1024: {
            slidesPerView: 5,
            spaceBetween: 20,
        },
    };

    const renderResults = () => (

    <Container>
        {<CustomSectionCreator title="Offers (Nearby Favs)" seeMoreLink="/offers/sort/favs" seeMoreLinkTitle="View more" />}
        <swiper-container slides-per-view="1.8" space-between="4" free-mode="true" breakpoints={JSON.stringify(breakpoints)}>
                { offers.map((offer, index) => (
                    <swiper-slide key={index}>
                        <Box sx={{ width: 150 }}>
                        <UserOfferBoxItem
                            offer={offer}
                            history={history}
                        />
                        </Box>
                    </swiper-slide>
                ))}
            </swiper-container>
    </Container>
    );

  return (

      <>
          {isLoading ? <MockProductBox />
              : offers.length > 0
                  ? renderResults()
                  : ""}

      </>


  );
};

UserOffersFavNearbySlider.defaultProps = {
  symbol: "$",
};

UserOffersFavNearbySlider.propTypes = {
    offers: PropTypes.arrayOf(PropTypes.object).isRequired,
  symbol: PropTypes.string,
    userMainGetFavNearbyOffers: PropTypes.func.isRequired,
};

// Mapping Props and State.
const userOffersFavNearbySlider = connect(
  ({ userMainOffers, bootupInfo }) => ({
    bootupInfo,
    reqStatus: userMainOffers.reqStatus,
    isLoading: userMainOffers.isLoading,
    serviceError: userMainOffers.serviceError,
    offers: userMainOffers.favnearbyofferlist,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(UserOffersFavNearbySlider);

export default userOffersFavNearbySlider;
